// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bookmark-body {
    padding: 0.5em;
    display: flex;
    flex-direction: column;
    min-height: 0;
}

h4.bookmark-header {
    display: flex;
    align-items: center;
    margin: 0;
}

h4.bookmark-header > span:first-child {
    flex: 1 1 auto;
}

div.bookmark-actions {
    margin: 0.5em 0;
}

div.bookmark-list {
    border: 1px solid var(--border-color);
    background-color: var(--list-bg-color);
    flex: 1 1 auto;
    overflow-y: auto;
}

div.bookmark-list-item {
    height: 2em;
    overflow: hidden;
    overflow-wrap: anywhere;
    display: flex;
    align-items: center;
}

div.bookmark-list-item > div.input-container {
    flex: 1 1 auto;
    border: none;
}

div.bookmark-list-item-empty {
    padding: 0.5em;
    font-style: italic;
    color: var(--text-color-disabled);
}

div.bookmark-list-item > span:first-child {
    flex: 1 1 auto;
    padding: 0 0.25em;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

div.bookmark-list-item > span.icon {
    flex: 0 0 1.5em;
}

div.bookmark-list-item > span.icon-trash:hover {
    color: red;
}

div.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even) {
    background-color: var(--list-item-bg-color-even);
}

div.bookmark-list-item:hover,
div.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even):hover {
    background-color: var(--list-item-bg-color-hover);
    color: var(--list-item-text-color-hover);
}

div.bookmark-list-item-active {
    background-color: var(--list-item-bg-color-active);
    color: var(--list-item-text-color-active);
}

div.bookmark-list-item-active:hover {
    background-color: var(--list-item-bg-color-active-hover);
    color: var(--list-item-text-color-active-hover);
}
`, "",{"version":3,"sources":["webpack://./components/style/BookmarkPanel.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,qCAAqC;IACrC,sCAAsC;IACtC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;IAEI,iDAAiD;IACjD,wCAAwC;AAC5C;;AAEA;IACI,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,+CAA+C;AACnD","sourcesContent":[".bookmark-body {\n    padding: 0.5em;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\nh4.bookmark-header {\n    display: flex;\n    align-items: center;\n    margin: 0;\n}\n\nh4.bookmark-header > span:first-child {\n    flex: 1 1 auto;\n}\n\ndiv.bookmark-actions {\n    margin: 0.5em 0;\n}\n\ndiv.bookmark-list {\n    border: 1px solid var(--border-color);\n    background-color: var(--list-bg-color);\n    flex: 1 1 auto;\n    overflow-y: auto;\n}\n\ndiv.bookmark-list-item {\n    height: 2em;\n    overflow: hidden;\n    overflow-wrap: anywhere;\n    display: flex;\n    align-items: center;\n}\n\ndiv.bookmark-list-item > div.input-container {\n    flex: 1 1 auto;\n    border: none;\n}\n\ndiv.bookmark-list-item-empty {\n    padding: 0.5em;\n    font-style: italic;\n    color: var(--text-color-disabled);\n}\n\ndiv.bookmark-list-item > span:first-child {\n    flex: 1 1 auto;\n    padding: 0 0.25em;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\ndiv.bookmark-list-item > span.icon {\n    flex: 0 0 1.5em;\n}\n\ndiv.bookmark-list-item > span.icon-trash:hover {\n    color: red;\n}\n\ndiv.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even) {\n    background-color: var(--list-item-bg-color-even);\n}\n\ndiv.bookmark-list-item:hover,\ndiv.bookmark-list-item:not(.bookmark-list-item-active):nth-child(even):hover {\n    background-color: var(--list-item-bg-color-hover);\n    color: var(--list-item-text-color-hover);\n}\n\ndiv.bookmark-list-item-active {\n    background-color: var(--list-item-bg-color-active);\n    color: var(--list-item-text-color-active);\n}\n\ndiv.bookmark-list-item-active:hover {\n    background-color: var(--list-item-bg-color-active-hover);\n    color: var(--list-item-text-color-active-hover);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
